import ProductApi from '../api-js/product.api';

export default class ProductService {
    static getProduct({siteId, identifier}) {
        return new Promise((resolve, reject) => {
            ProductApi.getProduct({siteId, identifier}).then((response) => {
                return response.json();
            }).then((data) => {
                resolve(data);
            }).catch((error) => {
                reject(error);
            });
        });
    }
}